import { http } from 'connex-cds';

export default {
  getPaymentMethod: ({ entityRef, paymentRef }) =>
    http.get({ apiName: 'mt', path: `/${entityRef}/payment-methods/${paymentRef}` }),
};
